// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"277221af","37":"84987ba3","171":"9226ab8a","429":"2688aa97","456":"38dbba45","507":"247e72f0"}[chunkId] + ".chunk.js";
};